import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    AppNotification,
    LoadDefaultsResult,
    NotificationPage,
    NotificationPreference,
    ReminderRule,
    ReminderRuleRequest,
    ReminderRulesView,
    ReminderRunResult,
} from '../interfaces/notification.interface';

const E = ENDPOINTS.NOTIFICATIONS;

export interface NotificationQuery {
    unreadOnly?: boolean;
    severity?: string;
    page?: number;
    size?: number;
}

export const NotificationService = {
    list: async (institutionId: string, q: NotificationQuery = {}): Promise<NotificationPage> =>
        (await axios.get(E.BASE, {
            params: {
                institutionId,
                unreadOnly: q.unreadOnly ?? false,
                severity: q.severity || undefined,
                page: q.page ?? 0,
                size: q.size ?? 20,
            },
        })).data,
    unreadCount: async (institutionId: string): Promise<number> =>
        (await axios.get(E.UNREAD_COUNT, { params: { institutionId } })).data.count,
    markRead: async (id: string): Promise<AppNotification> => (await axios.post(E.READ(id))).data,
    markAllRead: async (institutionId: string): Promise<number> =>
        (await axios.post(E.READ_ALL, null, { params: { institutionId } })).data.updated,
    getPreferences: async (institutionId: string): Promise<NotificationPreference> =>
        (await axios.get(E.PREFERENCES, { params: { institutionId } })).data,
    savePreferences: async (institutionId: string, pref: NotificationPreference): Promise<NotificationPreference> =>
        (await axios.put(E.PREFERENCES, pref, { params: { institutionId } })).data,
    rules: async (institutionId: string): Promise<ReminderRulesView> =>
        (await axios.get(E.RULES, { params: { institutionId } })).data,
    createRule: async (req: ReminderRuleRequest): Promise<ReminderRule> => (await axios.post(E.RULES, req)).data,
    updateRule: async (id: string, req: ReminderRuleRequest): Promise<ReminderRule> =>
        (await axios.put(E.RULE(id), req)).data,
    loadDefaults: async (institutionId: string): Promise<LoadDefaultsResult> =>
        (await axios.post(E.LOAD_DEFAULTS, null, { params: { institutionId } })).data,
    runNow: async (institutionId: string, sendEmail = false): Promise<ReminderRunResult> =>
        (await axios.post(E.RUN_NOW, null, { params: { institutionId, sendEmail } })).data,
};
